import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from '@mui/material/Box';
import './Project.css';
import ecommerce from '../../Assets/Projects/ecommerce.png';
import infoarch from '../../Assets/Projects/info_architecture.png';
import row1 from '../../Assets/Projects/row1.png';
import row2 from '../../Assets/Projects/row2.png';
import row3 from '../../Assets/Projects/row3.png';
import row4 from '../../Assets/Projects/row4.png';
import row5 from '../../Assets/Projects/row5.png';
import lowfi from '../../Assets/Projects/ecommerce_lowfi.png';
import compAnalysis from '../../Assets/Projects/competitive_analysis.png';
import persona1 from '../../Assets/Projects/persona1.png';
import persona2 from '../../Assets/Projects/persona2.png';
import styleguide from '../../Assets/Projects/styleguide.png';
import period from '../../Assets/period.svg';
import {Link} from 'react-router-dom';
import Navbar from "../Navbar";
import Footer from "../Footer";

function ECommerce() {

  return (
    <section>
      <Navbar />
      <Box className="filebox">

            <Row>
            <aside>
              <Col sm={1}>
                <Container style={{ height: '100%' }}>
             
            <div direction="right" className="side-banner">
            <div className="marquee">
              <div className="marquee-content" style={{animationDuration: '120s' }}>
                Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce         Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce         Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce         Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce         Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce         Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce         Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce         Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce         Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          Printing E-Commerce          
                </div>
                </div>
                </div>
                </Container>
              </Col>
              <Col sm={10} className="canteen-ui" style={{ paddingLeft: '130px', paddingRight: '70px' }}>
              <Container fluid className="project-section">
          <Container  className="canteen-content">
                <Row className="first-img" style={{ justifyContent: "center", paddingTop: '40px', paddingBottom: "40px" }}>

                <img
                      src={ecommerce}
                      alt="ecommerce"
                      className="img-fluid"
                      style={{marginBottom: '30px', padding: '0px', border: '1px solid white'}}
                    />
                  </Row>
                  <Row style={{paddingBottom: "40px"}}>
                  <div style={{display:'flex'}}>
                  <h1>Printing E-Commerce</h1>
                  <img
                    src={period}
                    alt="period"
                    className="img-fluid"
                    style={{marginLeft: '2px', paddingTop: '1%', verticalAlign: 'bottom' }}
                  />
                  </div>
                  <p className="content">A printing e-commerce that always businesses and individuals to easily create or use pre-made templates to fulfil their printing needs.</p>
                </Row>
                <Row style={{paddingBottom: "56px", fontFamily: 'Changa', fontSize: '1.2em'}} >
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">MY ROLE</p>
                    <p className="box-p">Research, Product Designer</p>
                    </div>
                    </Col>
                    
                    
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TIMELINE</p>
                    <p className="box-p">3 days</p>
                    </div>
                    </Col>
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TOOLS USED</p>
                    <p className="box-p">Figma</p>
                    </div>
                    </Col>
                </Row>
                <Row style={{paddingBottom: "40px"}}>
                    <Col>
                    <hr></hr>
                    <Row>
                    <div style={{display:'flex'}}>
                      <h2> THE BRIEF</h2> 
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    </Row>
                    <h5>PROMPT</h5>
                    <p className="content">Labelman Pvt. Ltd is one of the leading label printing machine manufacturers across the world. The company has been in presence for more than 30 years now, making them one of the pioneers in label printing technology. The company, now wants to expand it’s business in printing services hence they have decided to build an app which effectively caters to all printing needs and requirements for their clients.</p>
                    </Col>
                </Row>
                    
                <Row style={{paddingBottom: '56px'}}>
                    <Col>
                <hr></hr>
                <div style={{display: 'flex'}}>
                    <h2>USER RESEARCH</h2>
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                </div>
                    <h5 style={{paddingTop:"16px"}}>TARGET USERS:</h5>
                    <p className="content">
                    <ul>
                        <li>Small Business Owners (All printing needs)</li>
                        <li>Marketing Agencies (Various campaigns and promos)</li>
                        <li>Event Companies (Banners, posters, etc.)</li>
                        <li>Individuals (Wedding invitations, personalized business cards, etc.)</li>
                    </ul>
                    </p>

                    <h6 style={{paddingTop:"32px"}}>USER PERSONAS</h6>
                    
                    <img
                      src={persona1}
                      alt="User Persona"
                      className="img-fluid"
                      style={{paddingBottom: '56px'}}
                    />
                    <img
                      src={persona2}
                      alt="User Persona"
                      className="img-fluid"
                      style={{paddingBottom: '56px'}}
                    />

                    </Col>
                </Row>
                <Row style={{paddingBottom: "40px"}}>
                    <Col>
                <hr></hr>
                <div style={{display: 'flex'}}>
                    <h2>COMPETITIVE ANALYSIS
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '3%', verticalAlign: 'bottom' }}
                    /></h2>
                    </div>
                    <img
                      src={compAnalysis}
                      alt="Competitive Analysis"
                      className="img-fluid"
                      style={{paddingBottom: '56px'}}
                    />
                    </Col>
                </Row>
                <Row  style={{paddingBottom: "80px"}}>
                    <Col>
                <hr></hr>
                <div style={{display: 'flex'}}>
                    <h2>INFORMATION ARCHITECTURE</h2>
                    <img
                      
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    
                    </div>
                
                    <div className="img-wrapper">
                    <img
                      src={infoarch}
                      alt="Information Architecture"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    </Col>
                </Row>
                <Row style={{paddingBottom: '56px'}}>
                    <Col>
                    <hr></hr>
                    <div style={{display: 'flex'}}>
                    <h2>PROTOTYPE</h2>
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid"
                      style={{marginLeft: '2px', paddingBottom: '2.5%', verticalAlign: 'bottom' }}
                    />
                    </div>
                    <h5 style={{paddingBottom: '24px'}}>LOW FIDELITY:</h5>
                    <img
                      src={lowfi}
                      alt="low fidelity"
                      className="img-fluid"
                      style={{paddingBottom: '80px'}}
                    />
                    <h5>STYLE GUIDE:</h5>
                    <img
                      src={styleguide}
                      alt="visual identity"
                      className="img-fluid"
                    />
                    </Col>
                </Row>
                <Row style={{paddingBottom: '64px'}}>
                <h5 style={{paddingBottom: '64px'}}>HIGH FIDELITY/ FINAL DESIGN:</h5>
                <img
                      src={row1}
                      alt="High fidelity"
                      className="img-fluid"
                      style={{paddingBottom: '32px'}}
                    />
                <img
                      src={row2}
                      alt="High fidelity"
                      className="img-fluid"
                      style={{paddingBottom: '32px'}}
                    />
                <img
                      src={row3}
                      alt="High fidelity"
                      className="img-fluid"
                      style={{paddingBottom: '32px'}}
                    />
                <img
                      src={row4}
                      alt="High fidelity"
                      className="img-fluid"
                      style={{paddingBottom: '32px'}}
                    />
                <img
                      src={row5}
                      alt="High fidelity"
                      className="img-fluid"
                      style={{paddingBottom: '32px'}}
                    />
                </Row>
                

                <Row style={{marginBottom: "100px", paddingTop:"40px", fontFamily: 'Changa', fontSize: '1.2em'}}>
                  
                  <Link to={'/project/adwyzors'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute', right:'0px'}}>
                    Next
                    </div>
                  </Link>
                </Row> 
                </Container>
        </Container>
              </Col>
              </aside>
            </Row>
         
        <Footer />
      </Box>
    </section>
  );
}

export default ECommerce;
